var ImageIcon = require("components/utility/icons/ImageIcon");

require("utility/coin_display.scss");

var CoinDisplay = function(props) {
	var height = props.height || 30;
	var fontSize = height * 0.7;
	var top = height * 0.07;

	var style = props.style || {};
	style["fontSize"] = fontSize;

	var className = props.className || "";
	className += " coinDisplay";
	return (
		<span className={ className } style={ style }>
			<ImageIcon icon="coin" style={{ width: height, height: height }} />
			<span className="coinCount" style={{ top: top }}>{ props.coins }</span>
		</span>
	);
};

CoinDisplay.propTypes = StrictPropTypes({
	// How many coins there are
	coins: PropTypes.number.isRequired,

	// Height in pixels
	height: PropTypes.number,

	className: PropTypes.string,

	// CSS style object for the text
	style: PropTypes.object
});

//    {{{}}}
//   {{{  }}}
//  {{{ {} }}}
// {{{ {{}} }}}
//  {{{ {} }}}
//   {{{  }}}
//    {{{}}}

module.exports = CoinDisplay;



// WEBPACK FOOTER //
// ./modules/components/utility/CoinDisplay.js